import { openInNewTab, clickableCards, getPageId } from "./utils/utils";
import { loadState } from "./storage/storage";
import { getChecklistStats } from "./state/stateStats";
import { updateOverviewByPriority, updateOverviewProgress, updateSectionProgress } from "./progress/progress";
import { checkboxHandler } from "./checkboxes/checkbox";
import { ChecklistState } from "./state/state";

const STORAGE_KEY: string = "da-sec-info:checklist"

function init(): void {
  const state = loadState(STORAGE_KEY);
  const stats = getChecklistStats(state);
  openInNewTab();
  clickableCards();
  updateOverviewProgress(stats);
  updateOverviewByPriority(stats);
  updateSectionProgress(stats);
}

function benchmark(state: ChecklistState) {
  const start = performance.now();
  for (let i = 0; i < 1000; i++) {
    getChecklistStats(state);
  }
  const end = performance.now();
  console.log(`Average stats calulation over 1000 runs:\n${(end - start) / 1000} ms`);
}

document$.subscribe(
  function () {

    init();
    checkboxHandler(STORAGE_KEY, getPageId());

    // Uncomment if you like to assess
    // performance of building stats on the fly
    // benchmark(loadState(STORAGE_KEY));
  }
);
